export const getBooleanItem = (key: string) => {
  return localStorage.getItem(key) === "true";
};

export const setBooleanItem = (key: string, value: boolean) => {
  return localStorage.setItem(key, value ? "true" : "false");
};
